import React, {PureComponent, ReactNode} from 'react';
import I18n from 'app/i18n';
import SpriteIcon from 'app/utils/sprites/SpriteIcon';
import {startSteamAuthFlow} from 'app/utils/steamLink';
import {startGoogleAuthFlow} from 'app/utils/googleAuth';

interface Props {
    redirectUrl?: string;
}

export default class LoginSignWith extends PureComponent<Props> {
    handleGoogleClick = (): void => {
        const {redirectUrl} = this.props;

        startGoogleAuthFlow({redirectUrl});
    };

    handleSteamClick = (): void => {
        const {redirectUrl} = this.props;

        startSteamAuthFlow({redirectUrl});
    };

    render(): ReactNode {
        return (
            <div className="registration-sign-with">
                <div className="registration-sign-with__title">
                    <span>{I18n.t('sign_in_with')}</span>
                </div>
                <ul className="registration-sign-with__list">
                    <li>
                        <button
                            type="button"
                            className="button-sign-with"
                            onClick={this.handleGoogleClick}
                        >
                            <SpriteIcon name="#svg-google-icon" className="svg-default" />
                        </button>
                    </li>
                    <li>
                        <button
                            type="button"
                            className="button-sign-with"
                            onClick={this.handleSteamClick}
                        >
                            <SpriteIcon name="#svg-steam-icon" className="svg-default" />
                        </button>
                    </li>
                </ul>
            </div>
        );
    }
}
